import script from "./GetStarted.vue?vue&type=script&setup=true&lang=js"
export * from "./GetStarted.vue?vue&type=script&setup=true&lang=js"

import "./GetStarted.vue?vue&type=style&index=0&id=c0ea36c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0ea36c6"]])

export default __exports__